import { NgModule } from '@angular/core';

import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClipboardModule } from '@angular/cdk/clipboard';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { OverlayModule } from '@angular/cdk/overlay';


const imports=[
  MatSnackBarModule,
  MatTooltipModule,
  MatMenuModule,
  DragDropModule,
  ClipboardModule,
  ScrollingModule,
  MatDatepickerModule,
  OverlayModule

]

@NgModule({
  imports: [
    imports
  ],
  exports: [
    imports
  ]
})
export class MaterialModule {}
